import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {Textarea} from 'primeng/textarea';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-note',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Textarea
  ],
  template: `
    <div class="form-row">
      <label>{{ Yii.t('app', 'Note text') }}</label>
      <div>
        <textarea pTextarea [(ngModel)]="field.field_value" rows="5"></textarea>
      </div>
    </div>
  `,
})
export class FieldNote {
  Yii = Yii;
  @Input() field: any;
}
